<ng-container *transloco="let t; prefix: 'group-management.panels.edit-info'">
  @if (participant(); as person) {
    <app-panel-body>
      <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
        <div class="min-h-0 flex-1 overflow-y-auto">
          <app-content-container>
            @if (loading()) {
              <p>{{ t('loading') }}</p>
            } @else if (myInfoState(); as state) {
              <app-my-info-fields
                [form]="state.form"
                [fieldsByCategory]="state.fieldsByCategory"
                [specialtyCatalog]="specialtyCatalog()"
                [specialtyCatalogLoadFailed]="specialtyCatalogLoadFailed()"
                [specialtiesSelection]="specialtiesSelection()"
                [singleColumn]="true"
                (specialtiesSelectionChange)="onSpecialtiesSelectionChange($event)"
              />

              @if (ministrySurveyState(); as survey) {
                <app-ministry-survey-card [form]="survey.form" />
              } @else if (ministrySurveyLoadFailed()) {
                <app-inline-alert severity="danger" [message]="t('ministry-survey-load-error')" />
              }
            }
          </app-content-container>
        </div>

        <div class="flex shrink-0 justify-end gap-2 border-t border-primary-border px-4 py-4">
          <ion-button fill="outline" (click)="cancel()" [disabled]="submitting()">
            {{ t('cancel') }}
          </ion-button>
          <ion-button (click)="save()" [disabled]="submitting() || loading()">
            {{ t('save') }}
          </ion-button>
        </div>
      </div>
    </app-panel-body>
  }
</ng-container>
